import React from 'react';
import { SBA } from '../../theme';
import SafeImage from '../SafeImage';

export default function ImageMapReadingViewer({
  item,
  subjectColor = SBA.navy,
  passed = false,
  cleared = false,
  practiceOnly = false,
  onStartQuiz,
}) {
  const images = (item?.images || []).filter((img) => img?.url);
  const reading = String(item?.readingText || '').trim();
  const questionCount = Array.isArray(item?.questions) ? item.questions.length : 0;

  return (
    <div style={st.wrap}>
      <p style={st.kicker}>Social Studies · Images and map Readings</p>
      <h1 style={st.h1}>{item?.title || 'Visual image'}</h1>
      <p style={st.lead}>
        Study the visual image or map, then answer the MCQs written for this reading.
        These questions are stored with the image — no AI quiz is generated.
      </p>

      {passed || cleared ? (
        <div style={st.status(passed)}>
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            {passed ? 'verified' : 'check_circle'}
          </span>
          {passed
            ? 'You passed this reading. You can practice the MCQs again anytime.'
            : 'You moved on from this reading. You can still practice the MCQs.'}
        </div>
      ) : null}

      {images.map((img, i) => (
        <figure key={img.id || i} style={st.figure}>
          <SafeImage
            src={img.url}
            alt={img.description || item?.title || `Visual image ${i + 1}`}
            style={st.image}
          />
          {img.description ? <figcaption style={st.caption}>{img.description}</figcaption> : null}
        </figure>
      ))}

      {reading ? (
        <div style={st.reading}>
          <h2 style={st.h2}>Reading</h2>
          <p style={st.readingBody}>{reading}</p>
        </div>
      ) : null}

      <div style={st.actions}>
        <button type="button" onClick={onStartQuiz} style={{ ...st.cta, background: subjectColor }}>
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>quiz</span>
          {practiceOnly || passed || cleared
            ? `Practice MCQs again (${questionCount})`
            : `Start MCQs (${questionCount})`}
        </button>
      </div>
    </div>
  );
}

const st = {
  wrap: { maxWidth: 820 },
  kicker: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#64748b',
    margin: '0 0 8px',
  },
  h1: {
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    fontSize: 28,
    fontWeight: 800,
    color: '#1b1b1d',
    margin: '0 0 10px',
    letterSpacing: '-0.03em',
  },
  lead: { fontSize: 15, color: '#475569', lineHeight: 1.6, margin: '0 0 18px' },
  status: (passed) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 14px',
    borderRadius: 12,
    marginBottom: 16,
    background: passed ? '#f0fdf4' : '#fffbeb',
    color: passed ? '#15803d' : '#92400e',
    fontSize: 14,
    fontWeight: 600,
  }),
  figure: { margin: '0 0 16px' },
  image: {
    width: '100%',
    maxHeight: 480,
    objectFit: 'contain',
    borderRadius: 14,
    border: '1px solid #e2e8f0',
    background: '#f8fafc',
  },
  caption: { fontSize: 13, color: '#64748b', marginTop: 8, lineHeight: 1.5 },
  reading: {
    border: '1px solid #e2e8f0',
    borderRadius: 14,
    padding: 18,
    background: '#fff',
    marginBottom: 20,
  },
  h2: { fontSize: 15, fontWeight: 800, margin: '0 0 8px', color: '#1b1b1d' },
  readingBody: { fontSize: 15, color: '#334155', lineHeight: 1.7, whiteSpace: 'pre-wrap', margin: 0 },
  actions: { display: 'flex', gap: 10 },
  cta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '12px 16px',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
  },
};
